import { useQuery } from '@tanstack/react-query'

import type { GetReservationByIdResponse } from '../../types/reservation.js'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

/**
 * Demande de réservation relue par son propriétaire connecté.
 *
 * Le mur du nom est fait pour ceux qui n'ont pas de session : le demander à un
 * client connecté serait absurde.
 */
export const useGetMyReservationQuery = (reservationId: string, enabled: boolean) =>
  useQuery({
    enabled,
    queryFn: async () => {
      const response = await apiClient.client.get<GetReservationByIdResponse>(
        `/me/reservations/${reservationId}`
      )

      return response.data
    },
    queryKey: meKeys.reservation(reservationId),
  })
